import {NORMAL_WEIGHT, defaultFont} from './initial-state';

export function getStyleAttributes(modelData, element) {
  return {
    family: modelData.safeGet(`style.${element}.font.family`) || defaultFont.family,
    size: modelData.safeGet(`style.${element}.font.weight`) || defaultFont.size,
    style: modelData.safeGet(`style.${element}.font.style`) || defaultFont.style,
    weight: modelData.safeGet(`style.${element}.font.weight`) || NORMAL_WEIGHT
  };
}

export function normalizeOldFontWeight(modelData, weight, element) {
  if (weight === 'normal') {
    modelData.set(`style.${element}.font.weight`, NORMAL_WEIGHT);

    return NORMAL_WEIGHT;

  } else if (weight === 'bold') {
    modelData.set(`style.${element}.font.weight`, NORMAL_WEIGHT);
    modelData.set(`style.${element}.font.textStyles.strong`, true);

    return NORMAL_WEIGHT;
  }

  return weight;
}

export function getTextStyles(weight, style) {
  const strong = weight === 'bold';
  const em = style === 'italic';

  return {
    strong,
    em,
  };
}



// WEBPACK FOOTER //
// ./src/fonts/font-picker/form/helper.js